import { render, staticRenderFns } from "./desc.vue?vue&type=template&id=76ae16ba&scoped=true&"
import script from "./desc.vue?vue&type=script&lang=js&"
export * from "./desc.vue?vue&type=script&lang=js&"
import style0 from "./desc.vue?vue&type=style&index=0&id=76ae16ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ae16ba",
  null
  
)

export default component.exports